import React, { useEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import { Colors } from "@factorearth/component-library/dist/Theme/types";
import { FieldInstance, FieldTemplate } from "db/definitions";

const EmbeddedInput = styled.input<{ colorPalette: Colors }>`
	border: none;
	outline: none;
	background: transparent;

	font: inherit;
	font-weight: 600;
	color: ${({ colorPalette }) => colorPalette.text.primary};

	height: 24px;
	line-height: 24px;
	padding: 0;

	min-width: 0;
	width: 100%;

	::placeholder {
		font-weight: 500;
		color: ${({ colorPalette }) => colorPalette.text.secondary};
	}

	:disabled {
		color: ${({ colorPalette }) => colorPalette.text.secondary};
	}
`;

export type EmbeddedTextInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
	activeEditing?: boolean;
	colorPalette: Colors;
	fieldInstance: FieldInstance;
	fieldTemplate: FieldTemplate;
	onBlur: () => void;
};

export function EmbeddedTextInput(props: EmbeddedTextInputProps) {
	const { activeEditing, colorPalette, onChange, value, fieldInstance, fieldTemplate, onBlur, ...htmlProps } = props;
	console.log(`new value??? `, value);
	const ref = useRef<HTMLInputElement>(null);
	const [cursor, setCursor] = useState<number | null>(null);

	useEffect(() => {
		const input = ref.current;
		if (activeEditing && cursor !== null && input) {
			input.setSelectionRange(cursor, cursor);
		}
	}, [cursor, activeEditing, value]);

	const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
		onBlur();
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setCursor(e.target.selectionStart);
		onChange?.(e);
	};

	return <EmbeddedInput {...htmlProps} ref={ref} value={value} onChange={handleChange} onBlur={handleBlur} colorPalette={colorPalette} />;
}
